export const SERVIDORES_CEDIDOS = 'SERVIDORES_CEDIDOS';
export const SERVIDORES_CEDIDOS_START = 'SERVIDORES_CEDIDOS_START';
export const SERVIDORES_CEDIDOS_SUCCESS = 'SERVIDORES_CEDIDOS_SUCCESS';
export const SERVIDORES_CEDIDOS_ERROR = 'SERVIDORES_CEDIDOS_ERROR';
export const SERVIDORES_CEDIDOS_DETALHES = 'SERVIDORES_CEDIDOS_DETALHES';
